import React from "react";
import { useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import { getWorkflowSteps, getDefault } from "components/workflows/BalanceTransferWorkflow";
import TransferAmountView from "./components/TransferAmountView";
import "./styles.css";

/**
 * @function BalanceTransfersPage
 * @return {React.Component}
 * @exported true
 * @description The main component for BalanceTransfersPage.
 * Available routes:
 * <TransferAmountView />
   <TransferRecipientInfoView />
   <TransferReviewDetailsView />
   <TransferConfirmationView />
 */
export default function BalanceTransfersPage(props) {
  const navigate = useRoute();
  const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);

  const back = evt => {
    // If this is the first page in the Balance Transfer workflow,
    // go back to the main view (skip the security token pages).
    if(props.view.type === TransferAmountView) {
      navigate(-3);
    // Else go back to the previous Balance Transfer page.
    } else {
      workflowStep.workflow.prevStep();
    }
  }

  return (
    <MainContentContainer className="balance-transfers-page"
     header={<MainContentHeader text="Balance Transfer" onClick={ back } />}>
      { props.view }
    </MainContentContainer>
  );
}
